import React, { useEffect } from "react";
import Layout from "../components/Layout";
import PageTitle from "../components/PageTitle";
import { useSelector, useDispatch } from "react-redux";
import { listVisaDescription } from "../redux/actions/visaAction";
import { useParams, useSearchParams } from "react-router-dom";

const VisaScreen = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tag = searchParams.get("tag");
  const dispatch = useDispatch();
  const listVisaDescriptionState = useSelector(
    (state) => state.listVisaDescription
  );
  const { descriptions } = listVisaDescriptionState;
  useEffect(() => {
    dispatch(listVisaDescription(tag));
  }, [tag]);
  return (
    <Layout>
      <PageTitle
        title="Visa"
        description="Visa Description"
        button="Edit"
        link={`/edit-visa/${descriptions && descriptions.uuid}?tag=${tag}`}
      />
      <div className="card">
        <div class="card-body">
          <div class="card-title mb-4">
            <div
              dangerouslySetInnerHTML={{
                __html: descriptions && descriptions.description,
              }}
            ></div>
          </div>

          {/* <!-- end row --> */}
        </div>
      </div>
    </Layout>
  );
};

export default VisaScreen;
